import React from 'react';
import FadeInSection from './FadeInSection';


export default function TheApp() {
   const isLaunched = false;
  return (
    <>



   
  <section className="app-section">
      <div className="container">
        
        {/* Section Header */}
        <div className="text-center mb-5">
          <span className="section-label">THE OUTFITFIND APP</span>
          <h2 className="app-heading mt-2 mb-3">
            Your next outfit is <span>already put together.</span>
          </h2>
          <p className="app-description">
            Discover styled looks, explore every piece and save the outfits you love, all in one place.
          </p>

          {/* Launch Status / App Store Buttons Slot */}
          <div className="store-launch-container mt-4">
            {!isLaunched ? (
              /* BEFORE LAUNCH STATE */
              <div className="coming-soon-badge">
                <i className="bi bi-clock-history"></i>
                <span className="badge-main-text">APP COMING SOON</span>
                <span className="text-dim">|</span>
                <span className="badge-sub-text">Available on iOS & Android</span>
                <div className="store-icons-group ms-1">
                  <i className="bi bi-apple"></i>
                  <i className="bi bi-google-play ms-2"></i>
                </div>
              </div>
            ) : (
              /* AFTER LAUNCH STATE (Replace without changing layout) */
              <div className="d-flex align-items-center gap-3 flex-wrap justify-content-center">
                <a href="#app-store" className="btn btn-outline-light rounded-pill px-4 py-2">
                  <i className="bi bi-apple me-2"></i> App Store
                </a>
                <a href="#google-play" className="btn btn-outline-light rounded-pill px-4 py-2">
                  <i className="bi bi-google-play me-2"></i> Google Play
                </a>
              </div>
            )}
          </div>
        </div>

        {/* App Screens Showcase Row */}
        <div className="row g-4 align-items-center justify-content-center mt-3">
          
          {/* Screen 1: Home Feed */}
          <div className="col-lg-4 col-md-6">
            <div className="app-screen-card">
              <div className="screen-inner">
                <div className="screen-status-bar">
                  <span className="screen-title">Home Page</span>
                  <i className="bi bi-house-door text-muted"></i>
                </div>
                <img 
                  src="../../img/home-page-new.webp" 
                  alt="Home Feed Screen" 
                  className="screen-content-img"
                />
              </div>
              <div className="screen-caption">
                <p className="caption-label">01 / Home page</p>
                {/* <p className="caption-sub">Will have Gen Z trends, with global news n such.</p> */}
              </div>
            </div>
          </div>

          {/* Screen 2: Explore (Featured Center) */}
          <div className="col-lg-4 col-md-6">
            <div className="app-screen-card featured-center">
              <div className="screen-inner">
                <div className="screen-status-bar">
                  <span className="screen-title">Explore Page</span>
                  <i className="bi bi-search text-muted"></i>
                </div>
                <img 
                  src="../../img/explore.webp" 
                  alt="Explore Screen" 
                  className="screen-content-img"
                />
              </div>
              <div className="screen-caption">
                <p className="caption-label">02 / Explore Page</p>
                {/* <p className="caption-sub">Where all outfits will be.</p> */}
              </div>
            </div>
          </div>

          {/* Screen 3: Outfit Detail */}
          <div className="col-lg-4 col-md-6">
            <div className="app-screen-card">
              <div className="screen-inner">
                <div className="screen-status-bar">
                  <span className="screen-title">Community Space</span>
                  <i className="bi bi-bag-check text-muted"></i>
                </div>
                <img 
                  src="../../img/community-new.webp" 
                  alt="Outfit Detail Screen" 
                  className="screen-content-img"
                />
              </div>
              <div className="screen-caption">
                <p className="caption-label">03 / Community Space</p>
                {/* <p className="caption-sub">For contest, engaging purpose with users. Users can upload things in community space.</p> */}
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>

                      {/* Download Section */}
                        {/* <section className="download-section">
                          <div className="container">
                            <div className="text-center">
                              <div className="section-eyebrow" style={{ color: 'var(--peach)' }}>THE OUTFITFIND APP</div>
                              <h2 className="download-title">Your next outfit is . <span className="italic">already put together</span></h2>
                              <p className="download-subtitle">Discover styled looks, explore every piece and save the outfits you love, all in one
place.</p>
                            </div>
                
                            <FadeInSection className="phone-mockups">
                              <div className="phone-mockup-large">
                                <div className="phone-screen-inner">
                                  <div className="phone-notch"></div>
                                  <div className="phone-app-header">
                                    <div className="phone-app-title">LuxeGlow</div>
                                    <div className="phone-app-subtitle">For You</div>
                                  </div>
                                  <div className="phone-product-grid">
                                    <div className="phone-product"><img src="https://images.unsplash.com/photo-1556228720-195a672e8a03?w=300&h=400&fit=crop" alt="" /></div>
                                    <div className="phone-product"><img src="https://images.unsplash.com/photo-1512428813834-c702c7702b78?w=300&h=400&fit=crop" alt="" /></div>
                                    <div className="phone-product"><img src="https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=300&h=400&fit=crop" alt="" /></div>
                                    <div className="phone-product"><img src="https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=300&h=400&fit=crop" alt="" /></div>
                                  </div>
                                </div>
                              </div>
                              <div className="phone-mockup-large">
                                <div className="phone-screen-inner">
                                  <div className="phone-notch"></div>
                                  <div className="phone-app-header">
                                    <div className="phone-app-title">Daily Ritual</div>
                                    <div className="phone-app-subtitle">Skincare</div>
                                  </div>
                                  <div className="phone-product-grid">
                                    <div className="phone-product"><img src="https://images.unsplash.com/photo-1570194065650-d99fb4bedf0a?w=300&h=400&fit=crop" alt="" /></div>
                                    <div className="phone-product"><img src="https://images.unsplash.com/photo-1631730486572-226d1f595b68?w=300&h=400&fit=crop" alt="" /></div>
                                    <div className="phone-product"><img src="https://images.unsplash.com/photo-1585751119414-2d222b513f4d?w=300&h=400&fit=crop" alt="" /></div>
                                    <div className="phone-product"><img src="https://images.unsplash.com/photo-1599305445671-2d222b513f4d?w=300&h=400&fit=crop" alt="" /></div>
                                  </div>
                                </div>
                              </div>
                            </FadeInSection>
                
                          
                
                            <FadeInSection className="app-store-buttons">
                              <h3>APP COMING SOON + Available on iOS & Android.</h3>
                              <a href="#" className="store-button">
                                <i className="bi bi-apple"></i>
                                <div className="store-button-text">
                                  <small>Download on the</small>
                                  <span>APP COMING SOON</span>
                                </div>
                              </a> 
                              <a href="#" className="store-button">
                                <i className="bi bi-google-play"></i>
                                <div className="store-button-text">
                                  <small>Get it on</small>
                                  <span>Google Play</span>
                                </div>
                              </a>
                            </FadeInSection>
                
                          </div>
                        </section> */}


    </>

  )
}